
import React from 'react';

import './../Comp/Cards.css'


import { useEffect, useState } from 'react';




export const Rewards = () => {


       const [users, setUsers] = useState([]);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);
    
      useEffect(() => {
    
        const token = localStorage.getItem('token')
        console.log(token)
        const fetchUsers = async () => {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", `Bearer ${token}`);
    
    
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: new FormData(),
            redirect: "follow",
          };
    
          try {
            const response = await fetch(
              "https://backend.booknxtcoin.com/api/admin/stakes",
              requestOptions
            );
            const result = await response.json();
            if (result.code === 200 && result.status === "success") {
              setUsers(result.data.data);
            } else {
              setError("Failed to fetch users");
            }
          } catch (error) {
            setError(error.message);
          } finally {
            setLoading(false);
          }
        };
    
        fetchUsers();
      }, []);
    
      if (loading) return <p>Loading...</p>;
      if (error) return <p>Error: {error}</p>;
  return (
    <>
    {/* <div className='container'>
        <div className="row g-3 my-3 d-flex justify-content-center align-items-center">
              <div className="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-center">
                  <div className="card border-0 rounded-3 p-2" style={{backgroundColor:'#5696c9'}}>
                      <div className="crd-body">
                          <div className="crd-logo d-flex justify-content-end">
                              <HiSquaresPlus className='top-logo' size={70} style={{color:'#d1eafd'}} />
                          </div>
                          <div className="crd-text">
                              <h4 className='fw-bolder text-white'>Dashboard</h4>
                              <p className='fw-bolder text-white'>my dashboard and my <br/> locking and </p>
                          </div>
                          <div className="last-end d-flex justify-content-between align-items-center">

                              <HiPaperAirplane className='text-white'/>
                              <img className='img-fluid' src={one} />
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-center">
                  <div className="card border-0 rounded-3 p-2" style={{backgroundColor:'#c177ce'}}>
                      <div className="crd-body">
                          <div className="crd-logo d-flex justify-content-end">
                              <AiOutlineDatabase className='top-logo' size={70} style={{color:'#66396e'}}/>
                          </div>
                          <div className="crd-text">
                              <h4 className='fw-bolder text-white'>Datasets</h4>
                              <p className='fw-bolder text-white'>my dashboard and my <br/> locking and </p>
                          </div>
                          <div className="last-end d-flex justify-content-between align-items-center">

                              <HiPaperAirplane className='text-white'/>
                              <img className='img-fluid' src={two} />
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-center">
                  <div className="card border-0 rounded-3 p-2" style={{backgroundColor:'#ffc2d8'}}>
                      <div className="crd-body">
                          <div className="crd-logo d-flex justify-content-end">
                              <HiUsers className='top-logo' size={70} style={{color:'#ff81ae'}}/>
                          </div>
                          <div className="crd-text">
                              <h4 className='fw-bolder text-white'>User</h4>
                              <p className='fw-bolder text-white'>my dashboard and my <br/> locking and </p>
                          </div>
                          <div className="last-end d-flex justify-content-between align-items-center">

                              <HiPaperAirplane className='text-white'/>
                              <img className='img-fluid' src={three} />
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-center">
                  <div className="card border-0 rounded-3 p-2" style={{backgroundColor:'#ffc100'}}>
                      <div className="crd-body">
                          <div className="crd-logo d-flex justify-content-end">
                              <MdOutlineTimer className='top-logo' size={70} style={{color:'#fbebb3'}}/>
                          </div>
                          <div className="crd-text">
                              <h4 className='fw-bolder text-white'>Real-Time</h4>
                              <p className='fw-bolder text-white'>my dashboard and my <br/> locking and </p>
                          </div>
                          <div className="last-end d-flex justify-content-between align-items-center">

                              <HiPaperAirplane className='text-white'/>
                              <img className='img-fluid' src={four} />
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-center">
                  <div className="card border-0 rounded-3 p-2" style={{backgroundColor:'#287334'}}>
                      <div className="crd-body">
                          <div className="crd-logo d-flex justify-content-end">
                              <LiaMoneyBillWaveAltSolid className='top-logo' size={70} style={{color:'#71d080'}}/>
                          </div>
                          <div className="crd-text">
                              <h4 className='fw-bolder text-white'>Billing</h4>
                              <p className='fw-bolder text-white'>my dashboard and my <br/> locking and </p>
                          </div>
                          <div className="last-end d-flex justify-content-between align-items-center">

                              <HiPaperAirplane className='text-white'/>
                              <img className='img-fluid' src={five} />
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-center">
                  <div className="card border-0 rounded-3 p-2" style={{backgroundColor:'#ff5e5e'}}>
                      <div className="crd-body">
                          <div className="crd-logo d-flex justify-content-end">
                              <MdOutlineCampaign className='top-logo' size={70} style={{color:'#b34242'}}/>
                          </div>
                          <div className="crd-text">
                              <h4 className='fw-bolder text-white'>Campaign</h4>
                              <p className='fw-bolder text-white'>my dashboard and my <br/> locking and </p>
                          </div>
                          <div className="last-end d-flex justify-content-between align-items-center">

                              <HiPaperAirplane className='text-white'/>
                              <img className='img-fluid' src={six} />
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-center">
                  <div className="card border-0 rounded-3 p-2" style={{backgroundColor:'#ff8600'}}>
                      <div className="crd-body">
                          <div className="crd-logo d-flex justify-content-end">
                              <SiGooglecampaignmanager360 className='top-logo' size={70} style={{color:'#ffdbb3'}}/>
                          </div>
                          <div className="crd-text">
                              <h4 className='fw-bolder text-white'>Link</h4>
                              <p className='fw-bolder text-white'>my dashboard and my <br/> locking and </p>
                          </div>
                          <div className="last-end d-flex justify-content-between align-items-center">

                              <HiPaperAirplane className='text-white'/>
                              <img className='img-fluid' src={seven} />
                          </div>
                      </div>
                  </div>
              </div>
        </div>
    </div> */}
        <div className="container mt-4">
      <h2 className="mb-3">Reward List</h2>
      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>ID</th>
            <th>User ID</th>
            <th>Email</th>
            <th>Opening IP</th>
            <th>Closing</th>
            <th>Rate</th>
            <th>Status</th>
            <th>Created At</th>
            <th>Updated At</th>
          </tr>
        </thead>
        <tbody>

          {users.map((user) => (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.user_id}</td>
              <td>{user.user_email}</td>
              <td>{user.opening || "N/A"}</td>
              <td>{user.closing}</td>
              <td>{user.rate}</td>
              {/* <td>{user.hashkey}</td> */}
              <td>{user.status}</td>
              <td>{user.created_at}</td>
              <td>{user.updated_at}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    </>
  )
}
 